// extracted by mini-css-extract-plugin
module.exports = {"StyledContentSingleCard":"EAUO2","StyledContentSingleCard__landscape":"bK0g1","StyledContentSingleCard__portrait":"WsUrb"};